import script from "./Spinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=06578d0d&lang=scss"

const __exports__ = script;

export default __exports__